import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import {
  InputStyle,
  InputStyleWrapper,
  InputValidationMessage,
  LabeledInput,
} from '@getvim/atomic-ui';
import './InputField.less';

export const NpiInputField: React.FC = () => {
  const [field, meta, helpers] = useField('npi');
  const [isFocus, setIsFocus] = useState(false);

  // To disable non-numeric keys typing
  const onKeyPress = (event) => {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
  };

  const onDelete = () => {
    helpers.setValue('');
  };

  useEffect(() => setIsFocus(!!field.value), [field.value]);

  return (
    <div className="referral-request-input-container">
      <InputStyleWrapper inputStyle={InputStyle.pillMedium} hasError={meta.touched && !!meta.error}>
        <LabeledInput
          type="text"
          label="NPI"
          active={field.value || isFocus}
          onFocus={() => setIsFocus(true)}
          onBlurCapture={() => setIsFocus(false)}
          maxLength={10}
          onKeyPress={onKeyPress}
          autoComplete="off"
          {...field}
        />
        {meta.touched && !!meta.error && (
          <InputValidationMessage>{meta.error}</InputValidationMessage>
        )}
        {(isFocus || field.value) && (
          <button className="close-icon" type="button" onClick={onDelete}>
            <i className="icon-x" />
          </button>
        )}
      </InputStyleWrapper>
    </div>
  );
};
